<template>
  <Stage>
    <section>
      <img :src="image" />
    </section>
  </Stage>
</template>

<script>
import essComponentProps from '@/mixins/essComponentProps'
import { Stage } from '@neurotrack/web-shared-components'

export default {
  name: 'small_center_image',
  mixins: [essComponentProps],
  components: { Stage },
  computed: {
    image() {
      return this.getImageUrl(this.trialData?.body?.image?.filename)
    }
  }
}
</script>

<style scoped>
img {
  width: 100px;
  height: 100px;
}
</style>
